import { render, staticRenderFns } from "./detail_modal.vue?vue&type=template&id=6f98b98a&scoped=true&"
import script from "./detail_modal.vue?vue&type=script&lang=js&"
export * from "./detail_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f98b98a",
  null
  
)

export default component.exports